module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/pageIndex/ph-pic-16cac3.svg";